import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FolderModel } from 'entities/folder/model/folderModel';
import { foldersApi } from 'entities/folder/api/foldersApi';
import { useTranslation } from 'react-i18next';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import React, { useContext, useState } from 'react';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import ErrorModal from 'shared/lib/components/modals/errorModal';
import CreateFolder from 'widgets/folders/createFolder';

export type CreateFolderModalActions = {
  afterFolderCreate?: (folderModel: FolderModel) => void;
};

export default observer(function CreateFolderController({
  isOpen,
  sectionId,
  handleClose,
  afterFolderCreate,
  updateExplorerFolderList,
  parentId,
}: {
  isOpen: boolean;
  sectionId: string;
  parentId?: string | null;
  handleClose: () => void;
  updateExplorerFolderList?: () => void;
} & CreateFolderModalActions) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  const [dublicateName, setDublicateName] = useState<null | string>(null);

  return (
    <>
      <CreateFolder
        isOpen={isOpen}
        name={'Новая папка'}
        headerText={t('actions.creating.folder')}
        submitText={t('common.create')}
        handleClose={handleClose}
        onSubmit={async (params) => {
          try {
            if (parentId) {
              params.parent_id = parentId;
            }
            const newFolderData = await foldersApi.create(params, sectionId);

            afterFolderCreate &&
              afterFolderCreate(new FolderModel(newFolderData));
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.FolderExists
            ) {
              setDublicateName(params.name || '');
              return;
            }

            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
          handleClose();
        }}
      ></CreateFolder>

      {dublicateName && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setDublicateName(null)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Невозможно создать папку, так как папка с&nbsp;именем &laquo;
            <span style={{ fontWeight: 700 }}>{dublicateName}</span>&raquo; уже
            существует в&nbsp;текущем разделе
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
